// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { ActionIcon, Menu } from '@mantine/core';
import {
  IconArrowDownCircle,
  IconArrowUpCircle,
  IconBallpen,
  IconDeviceFloppy,
  IconDots,
  IconDotsVertical,
  IconStackPop,
  IconStackPush,
  IconTag,
  IconTrash,
  IconTrashX,
} from '@tabler/icons';
import { FC, useContext } from 'react';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../Service/LicenceS';
import { PositionS } from '../../../Service/PositionS';
import { PositionDto, PositionGroupDTO, PositionHandlers } from '../../../Service/DocumentT';
import { ProductsContext } from '../../../Service/Context/proxy/ProductsContext';
import { openSelectGroupModal } from './PositionGroupModals';
import { putFavoritePosition } from '../../../Service/restapi/positionService';
import { ToastS } from '../../../Service/ToastS';
import PositionModal from './PositionModals';
import { openEditPositionCategoryModal } from './AddProductModal';

interface Props {
  position: PositionDto;
  positionHandlers: PositionHandlers;
  positionGroups: PositionGroupDTO[];
  previewVersion?: boolean;
  isPartialInvoice?: boolean;
}

export const DocumentPositionActions: FC<Props> = ({
  position,
  positionHandlers,
  positionGroups,
  previewVersion,
  isPartialInvoice,
}) => {
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { swapPositions, deletePosition, openPositionModal, removePositionFromGroup, insertPositionIntoGroup } =
    positionHandlers;
  const { id: positionId, isFirst, isLast } = position;
  // const groupsAvailable = positionGroups.length !== 0;
  const movePosition = async (direction: string) => swapPositions(direction, positionId);

  return (
    <Menu shadow="md" width={200} transition="scale-y" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots size={20} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {previewVersion && (
          <Menu.Item icon={<IconBallpen size={16} />} onClick={() => openPositionModal(position)}>
            Bearbeiten
          </Menu.Item>
        )}
        <Menu.Item
          icon={<IconDeviceFloppy size={16} />}
          onClick={() =>
            executeWithLicenceCheck(LicenceS.Restrictions.PRODUCT_USAGE, () => PositionS.insertAsProduct(position))
          }
        >
          als Produkt speichern
        </Menu.Item>
        {/* {groupsAvailable && groupId && (
          <Menu.Item icon={<IconStackPop size={16} />} onClick={() => removePositionFromGroup(positionId)}>
            Gruppe verlassen
          </Menu.Item>
        )}
        {groupsAvailable && !groupId && (
          <Menu.Item
            icon={<IconStackPush size={16} />}
            onClick={() =>
              openSelectGroupModal({
                groups: positionGroups,
                onFinish: (id) => insertPositionIntoGroup(id, positionId),
              })
            }
          >
            In Gruppe einfügen
          </Menu.Item>
        )} */}
        {!isPartialInvoice && !isFirst && (
          <Menu.Item icon={<IconArrowUpCircle size={16} />} onClick={() => movePosition('UP')}>
            nach oben schieben
          </Menu.Item>
        )}
        {!isPartialInvoice && !isLast && (
          <Menu.Item icon={<IconArrowDownCircle size={16} />} onClick={() => movePosition('DOWN')}>
            nach unten schieben
          </Menu.Item>
        )}
        {!isPartialInvoice && previewVersion && (
          <Menu.Item color="red" icon={<IconTrash size={16} />} onClick={() => deletePosition(positionId)}>
            Löschen
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};

export const ProductPositionPreviewActions: FC<{
  position: PositionDto;
}> = ({ position }) => {
  const { openPositionModal, deleteProduct, categories, handleChange } = useContext(ProductsContext);

  return (
    <Menu shadow="md" transition="scale-y" position="bottom-end">
      <Menu.Target>
        <ActionIcon size="xs">
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item icon={<IconBallpen size={16} />} onClick={() => openPositionModal(position)}>
          Bearbeiten
        </Menu.Item>
        <Menu.Item
          icon={<IconTag size={16} />}
          onClick={() => {
            openEditPositionCategoryModal({
              product: position,
              categories,
              onConfirm: (value) => handleChange(position.id, { categoryId: value }),
            });
          }}
        >
          Kategorisieren
        </Menu.Item>
        <Menu.Item color="red" icon={<IconTrashX size={16} />} onClick={() => deleteProduct(position.id)}>
          Löschen
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
